// bp-wishlist v1.0 - Wishlist with localStorage + customer account sync
(function() {
  'use strict';

  var WL_KEY = 'bp_wishlist';
  var S = '.product-item, .card-wrapper, .product-card';

  // ---- Wishlist Storage ----
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WL_KEY)) || [];
    } catch(e) { return []; }
  }

  function saveWishlist(items) {
    localStorage.setItem(WL_KEY, JSON.stringify(items));
  }

  function isWishlisted(handle) {
    return getWishlist().some(function(item) { return item.handle === handle; });
  }

  function toggleWishlist(handle, data) {
    var list = getWishlist();
    var idx = list.findIndex(function(item) { return item.handle === handle; });
    if (idx > -1) {
      list.splice(idx, 1);
      saveWishlist(list);
      updateUI(handle, false);
      return false; // removed
    } else {
      list.push({
        handle: handle,
        variant_id: data.variant_id || '',
        title: data.title || handle,
        image: data.image || '',
        price: data.price || '',
        added_at: new Date().toISOString()
      });
      saveWishlist(list);
      updateUI(handle, true);
      // Sync to server if customer is logged in
      syncToServer(list);
      return true; // added
    }
  }

  // ---- Server Sync (for logged-in customers) ----
  function syncToServer(list) {
    // Check if customer is logged in (look for Shopify customer data)
    var customerId = null;
    try {
      // Check for common customer indicators
      var meta = document.querySelector('meta[name="customer-id"]');
      if (meta) customerId = meta.getAttribute('content');
      // Also check window __st customer data
      if (!customerId && window.__st && window.__st.customer) {
        customerId = window.__st.customer.id;
      }
    } catch(e) {}

    if (!customerId) return; // Guest user, no server sync needed

    // Fire and forget — save to our server
    try {
      fetch('/api/wishlist/sync', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: customerId, items: list })
      });
    } catch(e) {}
  }

  // ---- UI Updates ----
  function updateUI(handle, isActive) {
    // Update all heart icons for this handle
    document.querySelectorAll('.bp-wh[data-handle="' + handle + '"]').forEach(function(el) {
      el.classList.toggle('active', isActive);
      el.setAttribute('aria-label', isActive ? 'Remove from Wishlist' : 'Add to Wishlist');
      // Update SVG fill/stroke for golden-red effect
      var path = el.querySelector('svg path');
      if (path) {
        path.setAttribute('fill', isActive ? '#e11d48' : '#fff');
        path.setAttribute('stroke', isActive ? '#e11d48' : '#94a3b8');
      }
    });
    // Update counter
    updateCounter();
  }

  function updateCounter() {
    var count = getWishlist().length;
    var counter = document.querySelector('.bp-wlcbg');
    if (counter) {
      counter.textContent = count;
      var fc = document.querySelector('.bp-wlc');
      if (fc) { fc.style.display = count > 0 ? 'flex' : 'none'; }
    }
  }

  // ---- Show Wishlist Sidebar ----
  function showWishlistSidebar() {
    var old = document.getElementById('bp-wl-sidebar');
    if (old) { old.remove(); return; }

    var items = getWishlist();
    var overlay = document.createElement('div');
    overlay.id = 'bp-wl-sidebar';
    overlay.style.cssText = 'position:fixed;top:0;right:0;bottom:0;left:0;z-index:999999;display:flex;justify-content:flex-end;';

    var bg = document.createElement('div');
    bg.style.cssText = 'position:absolute;inset:0;background:rgba(0,0,0,0.5);';
    bg.onclick = function() { overlay.remove(); };

    var panel = document.createElement('div');
    panel.style.cssText = 'position:relative;width:380px;max-width:90vw;height:100%;background:#fff;box-shadow:-4px 0 30px rgba(0,0,0,0.15);overflow-y:auto;animation:bpFadeIn 0.25s ease;';

    var html = '<div style="padding:20px;border-bottom:1px solid #eee;display:flex;justify-content:space-between;align-items:center;">' +
      '<h2 style="margin:0;font-size:18px;font-weight:700;color:#333;">❤️ My Wishlist</h2>' +
      '<button onclick="this.closest(\'#bp-wl-sidebar\').remove()" style="background:none;border:none;font-size:22px;color:#999;cursor:pointer;padding:4px 8px;">✕</button>' +
    '</div>';

    if (items.length === 0) {
      html += '<div style="padding:40px 20px;text-align:center;color:#aaa;">' +
        '<p style="font-size:40px;margin:0 0 12px 0;">❤️</p>' +
        '<p style="font-size:14px;">Your wishlist is empty</p>' +
        '<p style="font-size:12px;">Click the ❤️ icon on any product to save it here</p>' +
      '</div>';
    } else {
      html += '<div style="padding:12px 16px;font-size:12px;color:#888;border-bottom:1px solid #f0f0f0;">' + items.length + ' item' + (items.length > 1 ? 's' : '') + '</div>';
      html += '<div style="padding:8px 16px;">';
      items.forEach(function(item) {
        html += '<div style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid #f5f5f5;align-items:center;">' +
          (item.image ? '<img src="' + item.image + '" style="width:60px;height:60px;object-fit:cover;border-radius:6px;flex-shrink:0;">' : '<div style="width:60px;height:60px;background:#f5f5f5;border-radius:6px;flex-shrink:0;"></div>') +
          '<div style="flex:1;min-width:0;">' +
            '<p style="margin:0 0 4px 0;font-size:13px;font-weight:600;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + (item.title || 'Product') + '</p>' +
            (item.price ? '<p style="margin:0;font-size:12px;color:#6366f1;font-weight:600;">' + item.price + '</p>' : '') +
          '</div>' +
          '<button onclick="toggleWishlist(\'' + item.handle + '\', {});showWishlistSidebar();" style="background:none;border:none;font-size:20px;cursor:pointer;padding:4px;color:#ef4444;">❤️</button>' +
        '</div>';
      });
      html += '</div>';
    }

    panel.innerHTML = html;
    overlay.appendChild(bg);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
  }

  // ---- Add Heart Icons to Product Cards ----
  function initWishlist() {
    // Create floating wishlist icon
    if (!document.querySelector('.bp-wlc')) {
      var f = document.createElement('div');
      f.className = 'bp-wlc';
      f.innerHTML = '<button class="bp-wlcb"><span style="font-size:24px;">❤️</span><span class="bp-wlcbg">' + getWishlist().length + '</span></button>';
      document.body.appendChild(f);
      f.onclick = function(e) {
        e.preventDefault();
        showWishlistSidebar();
      };
    }

    // Add hearts to product cards
    document.querySelectorAll(S).forEach(function(c) {
      if (c.querySelector('.bp-wh')) return; // Already has heart

      var h = c.getAttribute('data-product-handle');
      if (!h) {
        var j = c.getAttribute('data-json-product');
        if (j) { try { var p = JSON.parse(j); if (p.handle) h = p.handle; } catch(e) {} }
      }
      if (!h) {
        var l = c.querySelector('.card-title a, .card-title, .product-title a, a.card-title, a[href*="/products/"]');
        if (l) { var hr = l.getAttribute('href'); if (hr) { var m = hr.match(/\/products\/([^?#]+)/); if (m) h = m[1].split('?')[0]; } }
      }
      if (!h) return;

      // Extract product data for the wishlist
      var title = '';
      var img = '';
      var price = '';
      var variantId = '';

      var titleEl = c.querySelector('.card-title a, .card-title, .product-title a');
      if (titleEl) title = titleEl.textContent.trim();

      var imgEl = c.querySelector('.card-image img, .product-card-image img, img');
      if (imgEl) {
        img = imgEl.getAttribute('data-src') || imgEl.getAttribute('src') || '';
        if (img && !img.startsWith('http')) img = 'https:' + img;
      }

      var priceEl = c.querySelector('.price .price-item--sale, .price .price-item--regular, .price-item');
      if (priceEl) price = priceEl.textContent.trim();

      try {
        var jd = c.getAttribute('data-json-product');
        if (jd) { var pd = JSON.parse(jd); if (pd.variants && pd.variants[0]) variantId = pd.variants[0].id; }
      } catch(e) {}

      var active = isWishlisted(h);

      var heart = document.createElement('button');
      heart.className = 'bp-wh' + (active ? ' active' : '');
      heart.setAttribute('data-handle', h);
      heart.setAttribute('aria-label', active ? 'Remove from Wishlist' : 'Add to Wishlist');
      heart.innerHTML = '<svg viewBox="0 0 26 26" width="20" height="20"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill="' + (active ? '#e11d48' : '#fff') + '" stroke="' + (active ? '#e11d48' : '#94a3b8') + '" stroke-width="2.2"/></svg>';

      heart.onclick = function(e) {
        e.stopPropagation();
        e.preventDefault();
        var isAdded = toggleWishlist(h, {
          variant_id: variantId,
          title: title,
          image: img,
          price: price
        });
        // Show brief toast notification
        showToast(isAdded ? '❤️ Added to Wishlist' : '💔 Removed from Wishlist');
      };

      // Position heart at top-right of product card
      var container = c.querySelector('.card-product__wrapper, .card-product') || c;
      if (container) {
        container.style.position = 'relative';
        container.appendChild(heart);
      }
    });
  }

  // ---- Toast Notification ----
  function showToast(msg) {
    var old = document.getElementById('bp-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.id = 'bp-toast';
    t.textContent = msg;
    t.style.cssText = 'position:fixed;bottom:160px;left:50%;transform:translateX(-50%);background:#333;color:#fff;padding:10px 20px;border-radius:8px;font-size:13px;font-weight:600;z-index:9999999;box-shadow:0 4px 20px rgba(0,0,0,0.2);animation:bpFadeIn 0.2s ease;';
    document.body.appendChild(t);
    setTimeout(function() { t.style.opacity = '0'; t.style.transition = 'opacity 0.3s'; setTimeout(function() { t.remove(); }, 300); }, 1500);
  }

  // ---- Init ----
  initWishlist();
  setTimeout(initWishlist, 1000);
  setTimeout(initWishlist, 3000);
  new MutationObserver(function() { initWishlist(); }).observe(document.body, { childList: true, subtree: true });
})();
